import styled, { keyframes } from 'styled-components';

import { Popover as MUIPopover } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const Container = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .custom-button {
    width: 40px;
    height: 40px;
    padding: 0;
    min-width: auto;
    border-radius: 100%;
    background-color: #666666;
    color: #fff;

    svg {
      fill: #fff;
    }
  }
`;

export const Popover = withStyles({
  paper: {
    boxShadow: 'none',
    background: 'transparent',
    borderRadius: 0,
    overflowX: 'unset',
    overflowY: 'unset',
    '&::before': {
      content: '""',
      display: 'block',
      width: '100%',
      height: 12,
      background: 'transparent',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 2,
      right: '11.35rem',
      width: 10,
      height: 10,
      transform: 'translate(-50%, 50%) rotate(315deg)',
      backgroundColor: '#fff',
      clipPath:
        'polygon(-5px -5px, calc(100% + 5px) -5px, calc(100% + 5px) calc(100% + 5px))',
    },
  },
})(MUIPopover);

export const PopoverContent = styled('div')`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
`;

const bounce = keyframes`
  0%, 20%, 40%, 60%, 80%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
`;

export const CircleNotificationPending = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(255, 90, 95);
  position: absolute;
  height: ${props => (props?.height ? props.height : 0)};
  width: ${props => (props?.width ? props.width : 0)};
  margin-top: ${props => (props?.mt ? props.mt : 0)};
  margin-left: ${props => (props?.ml ? props.ml : 0)};
  margin-right: ${props => (props?.mr ? props.mr : 0)};
  border-radius: ${props => (props?.borderRadius ? props.borderRadius : 0)};
  animation: ${bounce} 1.5s linear infinite;

  & > div {
    justify-content: center;
    line-height: 18px;
    color: #fff;
  }
`;
